import React from 'react';
import { withTranslation } from 'react-i18next';

class CustomerSupportEmails extends React.PureComponent {
    render() {
        return (
            <div className="customer-support-item customer-support-item--email">
                <h5 className="customer-support-item__title fo-icon fo-icon-Email">
                    {this.props.t('common:customerSupport.titleEmail')}
                </h5>
                <a
                    href="https://lexisnexis.custhelp.com/app/forms/newsdesk"
                    target="_blank"
                    rel="noreferrer"
                    className="customer-support-item__list-link"
                >
                    {this.props.t('common:customerSupport.clickHereForCustomerSupport')}
                </a>
            </div>
        );
    }
}

export default withTranslation(['common'])(CustomerSupportEmails);
